export const fromNanoToUnit = (amount: number): number => {
    const unit = amount / 10**9
    const regexp = new RegExp('^-?\\d+(?:\.\\d{0,2})?');
    const truncated = unit.toString().match(regexp)?.[0] as string
    return Number(truncated);
}

export const fromNanoToLocaleBalance = (balance: number): string => {
    const formatter = Intl.NumberFormat('ru', { notation: 'compact' })
    const standartUnits = parseFloat((balance / 10**9).toFixed(2))
    const text = formatter.format(standartUnits)
    return text
}
